const languages = [
  {
    id: 1,
    name: "tr",
    header: [
      {
        titleName: " - Doğru Teknolojiye Ulaşmanın En Hızlı Yolu",
        description:
          "Firmanızın ihtiyaçlarını belirleyelim ve sizi en uygun teknoloji çözümleriyle buluşturalım.",
        canonical: "",
      },
    ],
    sections: [
      {
        id: 1,
        name: "Navbar",
        keys: [
          {
            k0001: "Giriş Yap",
          },
          {
            k0002: "Hizmetler",
          },
          {
            k0003: "Referanslar",
          },
          {
            k0004: "Avantajlar",
          },
          {
            k0005: "Çözüm Ortakları",
          },
          {
            k0006: "SSS",
          },
          {
            k0007: "İletişim",
          },
          {
            k0008: "TR",
          },
        ],
      },
      {
        id: 2,
        name: "Header",
        keys: [
          {
            k0001: "Doğru Teknolojiye Ulaşmanın En Hızlı Yolu",
          },
          {
            k0002:
              "Firmanızın ihtiyaçlarını belirleyelim ve sizi en uygun teknoloji çözümleriyle buluşturalım.",
          },
          {
            k0003: "İletişime Geçin",
          },
        ],
      },
      {
        id: 3,
        name: "Banner Bottom",
        keys: [
          {
            k0001:
              "BANDWITT Platformu, sizi en uygun teknoloji çözümleri ile eşleştirerek, firmanızın iş süreçlerindeki teknoloji kullanımını arttırır ve dijital dönüşümünüzü en hızlı ve en etkin şekilde gerçekleştirmenizi sağlar.",
          },
          {
            k0002: "İhtiyaç Belirleme",
          },
          {
            k0003:
              "BANDWITT Platformu’na üye olduğunuzda, öncelikle firmanızı 5 ana kategoride hızlı bir analizden geçirerek, mevcuttaki teknoloji kullanımınızı ölçüyoruz.",
          },
          {
            k0004:
              "Daha verimli çalışmanız için ihtiyacınız olan en uygun teknoloji projelerini belirleyerek, süre ve bütçeleriyle paylaşıyoruz.",
          },
          {
            k0005: "Eşleştirme",
          },
          {
            k0006:
              "Türkiye’de ve globalde farklı uzmanlık alanlarında hizmet veren teknoloji çözümlerini inceleyerek, firmaları en doğru çözümlerle buluşturuyoruz.",
          },
          {
            k0007:
              "Bu aşamada, firmanızı ihtiyaç duyduğu projeleri hayata geçirebilecek en uygun çözüm ortaklarıyla eşleştiriyoruz.",
          },
          {
            k0008: "Proje Takibi",
          },
          {
            k0009:
              "Projelerinizi hayata geçirirken, süreci daha kolay takip etmek için BANDWITT Platformu’nu kullanabilirsiniz.",
          },
          {
            k0010:
              "Firmanızda proje takibinden sorumlu bir ekip olmaması durumunda, BANDWITT danışmanlarından destek alabilirsiniz.",
          },
        ],
      },
      {
        id: 4,
        name: "Logo Section",
        keys: [
          {
            k0001: "200’den Fazla Firma Deneyimi",
          },
          {
            k0002:
              "BANDWITT platformu, sektör ve ölçek kısıtı olmadan, ihtiyacınız olan en doğru teknoloji çözümlerine hızlı ve kolay ulaşmanızı sağlar.",
          },
        ],
      },
      {
        id: 5,
        name: "Collaboration",
        keys: [
          {
            k0001: "İş Birliklerimiz",
          },
        ],
      },
      {
        id: 6,
        name: "Advantages",
        keys: [
          {
            k0001: "Avantajlar",
          },
          {
            k0002: "Hızlı",
          },
          {
            k0003: "1 ay içinde tamamlanan analiz süreci",
          },
          {
            k0004: "Ortalama 3-6 ay arasında devreye alınan projeler",
          },
          {
            k0005:
              "Aylarca süren ‘’analizler döngüsü’’ nedeniyle uygulamaya geçememek yerine, iş süreçlerinizdeki teknoloji kullanımını hızlıca arttırabilirsiniz.",
          },
          {
            k0006: "Çözüm Ortağı",
          },
          {
            k0007: "Havuzu",
          },
          {
            k0008:
              "İhtiyacınıza uygun, doğru teknolojiyi sunabilecek çözüm ortağı havuzu",
          },
          {
            k0009:
              "Çözüm ortaklarımızdan özel indirim ve bedelsiz demo imkanları",
          },
          {
            k0010: "Gelişmiş teknoloji ile kolay satın alma süreci",
          },
          {
            k0011:
              "Teknoloji çözümlerine ulaşmaktaki ve teknoloji satın almasındaki zorlukları, geniş çözüm ortağı havuzumuzla aşabilirsiniz.",
          },
          {
            k0012: "Uçtan Uca",
          },
          {
            k0013: "Analizden uygulamaya kadar, uçtan uca destek imkanı",
          },
          {
            k0014:
              "Tüm sürecin platformda görüntülenmesi, takibi ve raporlanması",
          },
          {
            k0015:
              "Projelerinizde kağıt üstünde kalan fikirler olmaktan çıkıp, hayata geçebilmesi için her adımda desteğe sahip olursunuz.",
          },
          {
            k0016: "Esnek",
          },
          {
            k0017: "Aylık, esnek üyelik modeli",
          },
          {
            k0018: "Sabit ödenen ücretler",
          },
          {
            k0019:
              "Toplu ve genelde döviz bazlı ödenen yüksek ücretli danışmanlıklar yerine, esnek üyelik modelimizle bütçenizi daha iyi kontrol edebilirsiniz.",
          },
          {
            k0020: "İletişime Geçin",
          },
        ],
      },
      {
        id: 7,
        name: "Application",
        keys: [
          {
            k0001: "BANDWITT Çözüm Ortakları Havuzu’na Katılın!",
          },
          {
            k0002:
              "BANDWITT olarak çözüm ortakları havuzumuz her geçen gün büyüyor. Bugün alanında uzman, 150’den fazla teknoloji firması BANDWITT’le çalışıyor ve sağladıkları ürün ve hizmetlere doğrudan ihtiyaç duyan üye firmalarla eşleşiyor.",
          },
          {
            k0003: "Ad ve Soyad",
          },
          {
            k0004: "Email",
          },
          {
            k0005: "Telefon",
          },
          {
            k0006: "Firma İsmi",
          },
          {
            k0007: "Firma Uzmanlık Alanı",
          },
          {
            k0008: "Mesajınız",
          },
          {
            k0009: "Ücretsiz Katılın",
          },
          {
            k0010: "Firma Uzmanlık Alanı",
          },
          {
            k0011: "Diğer",
          },
          {
            k0012: "Mesajınız",
          },
          {
            k0013: "KVKK Aydınlatma Metnini",
          },
          {
            k0014: "okudum, kabul ediyorum",
          },
          {
            k0015: "Önemli kampanyalardan haberdar olmak için",
          },
          {
            k0016: "Açık Rıza Metni",
          },
          {
            k0017: "kapsamında elektronik ileti almak istiyorum.",
          },
          {
            k0018: "Ücretsiz Katılın",
          },
          {
            k0019: "Başarıyla katıldınız.",
          },
        ],
      },
      {
        id: 8,
        name: "FAQ",
        keys: [
          {
            k0001: "Sıkça Sorulanlar",
          },
          {
            k0002:
              "BANDWITT Platformu ile ilgili en çok sorulan soruların cevaplarını burada bulabilirsiniz. Merak ettiğiniz diğer her türlü konu ve soru için",
          },
          {
            k0003: "bizimle iletişime geçebilirsiniz.",
          },
          {
            k0004: "Sadece büyük ölçekli firmalarla mı çalışıyorsunuz?",
          },
          {
            k0005:
              "BANDWITT Platformu’nun amacı, ölçeğinden bağımsız olarak tüm firmaların ihtiyaç duyduğu doğru teknolojilere ulaşmasını sağlamak. Üye firmalarımız arasında, mikro-KOBİ’ler, KOBİ’ler ve Büyük Ölçekli İşletmeler gibi her ölçekten firmalar bulunmakta.",
          },
          {
            k0006: "Her sektörden firmaya hizmet veriyor musunuz?",
          },
          {
            k0007:
              "Evet. Bazı teknoloji çözümleri sektörden bağımsız birçok sektöre uygunken, bazı durumlarda ise sektöre özgü çözümlere ihtiyaç duyulabiliyor. Firmanız özelindeki ihtiyaçları değerlendirerek sizleri en uygun çözüm ortakları ile eşleştiriyoruz.  ",
          },
          {
            k0008:
              "Projelerde kendi çözüm ortaklarımızla çalışabilir miyiz? Yoksa sizin havuzunuzda yer alan çözüm ortaklarıyla mı çalışmak zorundayız?",
          },
          {
            k0009:
              "Projelerde sizin halihazırda çalıştığınız ya da önerdiğiniz çözüm ortaklarıyla da ilerleyebiliriz. Ama burada dikkat edilmesi gereken nokta, çözüm ortağınızın, yürütülecek projedeki teknoloji ihtiyacını karşılayabilmesi. Bazen firmalar çalıştıkları çözüm ortaklarını bu açıdan değerlendiremiyor. O nedenle böyle bir durum olduğunda, sizden sürece bizi de dahil etmenizi istiyoruz. Böylece biz de ilgili çözüm ortağını değerlendirebilir, görüş verebilir ve olası risklere karşı sizleri uyarabiliriz. ",
          },
          {
            k0010:
              "Hizmetinizi nasıl ücretlendiriyorsunuz? İstediğimiz zaman üye olabilir veya üyelikten çıkabilir miyiz?",
          },
          {
            k0011:
              "BANDWITT Platformu aylık üyelik sistemi ile çalışan bir ödeme modeline sahip. Şu an için iki ayrı üyelik türümüz var ve şirketinizin ihtiyaçlarına göre hangi üyelik türünün size daha uygun olacağını sizlerle beraber belirliyoruz.",
          },
          {
            k0012:
              "Üyemiz olarak kaldığınız süre boyunca, Türk Lirası olarak, aylık sabit bir ücret ödüyorsunuz. Hizmetimizden memnun kalmazsanız ya da ara verme ihtiyacı duyarsanız, ilgili ay içinde üyeliğinizi iptal edebilirsiniz.",
          },
        ],
      },
      {
        id: 9,
        name: "Contact",
        keys: [
          {
            k0001:
              "Firmanızın ihtiyaçlarını belirleyelim ve sizi en uygun teknoloji çözümleriyle buluşturalım.",
          },
          {
            k0002: "Ad ve Soyad",
          },
          {
            k0003: "Email",
          },
          {
            k0004: "Telefon",
          },
          {
            k0005: "Firma İsmi",
          },
          {
            k0006: "Mesajınız",
          },
          {
            k0007: "Gönder",
          },
          {
            k0008: "KVKK Aydınlatma Metnini",
          },
          {
            k0009: "okudum, kabul ediyorum",
          },
          {
            k0010: "Önemli kampanyalardan haberdar olmak için",
          },
          {
            k0011: "Açık Rıza Metni",
          },
          {
            k0012: "kapsamında elektronik ileti almak istiyorum.",
          },
          {
            k0013: "Mesajınız gönderildi.",
          },
        ],
      },
      {
        id: 10,
        name: "Footer",
        keys: [
          {
            k0001: "Giriş Yap",
          },
          {
            k0002: "Hizmetler",
          },
          {
            k0003: "Referanslar",
          },
          {
            k0004: "Avantajlar",
          },
          {
            k0005: "Çözüm Ortakları",
          },
          {
            k0006: "SSS",
          },
          {
            k0007: "İletişim",
          },
          {
            k0008: "Açık Rıza Metni",
          },
          {
            k0009: "Gizlilik Politikası",
          },
          {
            k0010: "KVKK Politikası",
          },
          {
            k0011: "Çerez Politikası",
          },
          {
            k0012: "Tüm Hakları Saklıdır",
          },
        ],
      },
      {
        id: 11,
        name: "Company's Expertise Area",
        keys: [
          {
            k0001: "3D Teknolojileri",
          },
          {
            k0002: "Araç Teknolojileri",
          },
          {
            k0003: "Ağ ve Alt Yapı Çözümleri",
          },
          {
            k0004: "Barkod Yazıcı ve Çözümleri",
          },
          {
            k0005: "Blockzincir",
          },
          {
            k0006: "Bulut İletişim Teknolojileri",
          },
          {
            k0007: "Büyük Veri Yönetimi",
          },
          {
            k0008: "Chatbot Uygulamaları",
          },
          {
            k0009: "Dijital İkiz Teknolojisi",
          },
          {
            k0010: "Dijital Giriş Çözümleri",
          },
          {
            k0011: "Dijital Pazarlama",
          },
          {
            k0012: "Doküman Yönetim Sistemi",
          },
          {
            k0013: "Drone Teknolojileri",
          },
          {
            k0014: "E-İmza ve Mobil İmza Teknolojileri",
          },
          {
            k0015: "E-Ticaret Platformları",
          },
          {
            k0016: "Entegre Yönetim Sistemleri",
          },
          {
            k0017: "Eğitim Teknolojileri",
          },
          {
            k0018: "Finans Teknolojileri (Fintech)",
          },
          {
            k0019: "Görüntü İşleme Teknolojileri (OCR)",
          },
          {
            k0020: "Hukuk Teknolojileri",
          },
          {
            k0021: "İK Platformları",
          },
          {
            k0022: "İleri Planlama Sistemleri",
          },
          {
            k0023: "İleri Üretim Teknolojileri",
          },
          {
            k0024: "İş Akış Yönetimi Sistemleri",
          },
          {
            k0025: "Kimlik Doğrulama Teknolojileri",
          },
          {
            k0026: "Kurumsal Yönetim Sistemleri (ERP)",
          },
          {
            k0027: "Müşteri Yönetim Sistemleri (CRM)",
          },
          {
            k0028: "Nesnelerin İnterneti (IoT)",
          },
          {
            k0029: "Platform Teknolojileri",
          },
          {
            k0030: "Raporlama Çözümleri",
          },
          {
            k0031: "Robotik Süreç Otomasyonu (RPA)",
          },
          {
            k0032: "Saha Yönetimi Sistemleri",
          },
          {
            k0033: "Sanal ve Artırılmış Gerçeklik Teknolojileri (AR/VR)",
          },
          {
            k0034: "Sağlık Teknolojileri",
          },
          {
            k0035: "Siber Güvenlik Çözümleri",
          },
          {
            k0036: "Sigorta Teknolojileri",
          },
          {
            k0037: "Tahminleme Teknolojileri",
          },
          {
            k0038: "Tarım Teknolojileri",
          },
          {
            k0039: "Web ve Mobil Uygulamalar",
          },
          {
            k0040: "Yapay Zeka ve Makine Öğrenmesi (AI/ML)",
          },
        ],
      },
      {
        id: 12,
        name: "URL Links",
        keys: [
          {
            k0001: "hizmetler",
          },
          {
            k0002: "referanslar",
          },
          {
            k0003: "avantajlar",
          },
          {
            k0004: "uygulama",
          },
          {
            k0005: "sss",
          },
          {
            k0006: "iletisim",
          },
        ],
      },
      {
        id: 13,
        name: "Slide",
        keys: [
          {
            k0001:
              "Günümüzde dijital dönüşüm, şirketler için bir tercih değil, zorunluluk; aynı zamanda da süreklilik arz eden, adeta yeni bir departman olarak çalışmalı.",
          },
          {
            k0002:
              "BANDWITT'i de bu vizyonu paylaştığı ve projeleri yönetirken bir o kadar da sürekliliğe ve eğitime verdiği önem sebebiyle tercih ettik. ",
          },
          {
            k0003:
              "Şirketimiz için kritik önem taşıyan “Dijital Dönüşüm” sürecimizde BANDWITT, doğru ve kapsamlı analizleri ile bizi her aşamada gerekli uygulamalara yönlendirmiş ve doğru çözüm ortakları ile bir araya getirmiştir. ",
          },
          {
            k0004:
              "ERP, üretim, depo, saha satış, raporlama ve diğer birçok alandaki önemli projenin her aşamasında bize gerek profesyonel/teknik açıdan ve gerekse motivasyon/yönlendirme açısından çok değerli destekler sağlamışlardır.",
          },
          {
            k0005:
              "Kendilerine sağladıkları değerli katkıları için çok teşekkür ediyoruz.",
          },
          {
            k0006: "Muhasebe ve Bütçe Planlama Müdürü",
          },
          {
            k0007:
              "BANDWITT, hızla değişen teknoloji ve artan müşteri beklentileri ile birleşen pandemi ve ekonomik kriz ortamında, işletmelerin teknoloji ve dijitalleşme yatırımlarını gerçekleştirebilmelerinde birlikte çalışabilecekleri çok önemli bir stratejik ortak.",
          },
          {
            k0008:
              "İşletmeler, bu zorlu iş ortamında, BANDWITT’in bilgi ve uzmanlığından faydalanarak, her türden teknoloji sağlayıcısı ile buluşabilir. Ekibin sunduğu pratik rehberlik sayesinde gitgide daha fazla seçeneğin ortaya çıktığı teknoloji ekosisteminde kendilerine en uygun çözümlerini hayata geçirebilirler.",
          },
          {
            k0009: "Kıdemlı Proje Müdürü & Bankacılık Sektör Uzmanı",
          },
          {
            k0010:
              "Gelişen teknoloji trendlerini takip etmek ve işletme gereksinimlerini karşılamak adına başlatmış olduğumuz dijitalleşme sürecimizde, hem dijitalleşmenin daha hızlı sonuçlandırılması, hem de farklı bakış açılarınından yararlanmak için BANDWITT ile güzel bir başlangıç yaptık. ",
          },
          {
            k0011:
              "Yapılan değerlendirmeler ve  toplantılar daha net adımlar atmamızı sağlarken, BANDWITT’ın çözüm ortakları havuzunun geniş olması, alternatif üretme noktasında ciddi bir avantaj oluşturdu.",
          },
          {
            k0012:
              "Destekleri ve iş birlikleri için BANDWITT’e çok teşekkür ederiz.",
          },
          {
            k0013:
              "BANDWITT’le beraber çalışarak dijitalleşme kasımızı geliştirdik ve zorlu pandemi sürecine rağmen, dijitalleşme sürecinde BANDWITT sayesinde hızlı adımlar attık.",
          },
          {
            k0014: "Genel Müdür",
          },
          {
            k0015: "BT Müdürü ",
          },
        ],
      },
      {
        id: 14,
        name: "Whatsapp Text",
        keys: [
          {
            k0001:
              "Merhaba, BANDWITT hizmetleri hakkinda bilgi almak istiyorum.",
          },
        ],
      },
      {
        id: 15,
        name: "Email Popup",
        keys: [
          {
            k0001:
              "Firmam için en doğru teknoloji çözümlerine ulaşmak istiyorum!",
          },
          {
            k0002: "Email Adresinizi giriniz",
          },
          {
            k0003: "Gönder",
          },
          {
            k0004: "Emailiniz başarıyla gönderildi.",
          },
          {
            k0005: "Emailiniz gönderilemedi.",
          },
          {
            k0006: "Lütfen email adresinizi giriniz!",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "en",
    header: [
      {
        titleName: "- Smart Matchmaking for Technology",
        description:
          "Let us determine the needs of your company and bring you together with the most suitable technology solutions.",
        canonical: "en",
      },
    ],
    sections: [
      {
        id: 1,
        name: "Navbar",
        keys: [
          {
            k0001: "Login",
          },
          {
            k0002: "Services",
          },
          {
            k0003: "References",
          },
          {
            k0004: "Advantages",
          },
          {
            k0005: "Solution Providers",
          },
          {
            k0006: "FAQ",
          },
          {
            k0007: "Contact",
          },
          {
            k0008: "EN",
          },
        ],
      },
      {
        id: 2,
        name: "Header",
        keys: [
          {
            k0001: "Smart Matchmaking for Technology",
          },
          {
            k0002:
              "We identify your company’s needs and offer you the most suitable technology solutions.",
          },
          {
            k0003: "Contact Us",
          },
        ],
      },
      {
        id: 3,
        name: "Banner Bottom",
        keys: [
          {
            k0001:
              "BANDWITT Platform increases the use of technology in your company's business processes and drafts a digital transformation proposal by informing you of the most suitable technology solutions.",
          },
          {
            k0002: "Identification of the Needs",
          },
          {
            k0003:
              "When you become a member of BANDWITT Platform, we first analyze your company in 5 main categories and assess your current technology usage.",
          },
          {
            k0004:
              "We identify the most suitable technology oriented projects that you need to implement in order to improve your business processes and we share these projects with their estimated duration and budget alongside its details.",
          },
          {
            k0005: "Matchmaking",
          },
          {
            k0006:
              "Our team will examine each case thoroughly to bring along the most targeted solutions and experts from respective fields who operate both in Turkey and globally.",
          },
          {
            k0007:
              "At this stage, we match your company with the most suitable solution partners who can realize the projects it needs.",
          },
          {
            k0008: "Project Management",
          },
          {
            k0009:
              "You can use BANDWITT Platform to track & monitor your projects’ status with ease.",
          },
          {
            k0010:
              "In case you do not have an employee or a team for monitoring your projects, you can always get additional support from BANDWITT consultants.",
          },
        ],
      },
      {
        id: 4,
        name: "Logo Section",
        keys: [
          {
            k0001: "Experience working with more than +200 Clients",
          },
          {
            k0002:
              "BANDWITT Platform enables your company to access and find the most suitable technology solutions in a fast and easy way regardless of the sector or the scale of your company.",
          },
        ],
      },
      {
        id: 5,
        name: "Collaboration",
        keys: [
          {
            k0001: "Collaborations & Projects",
          },
        ],
      },
      {
        id: 6,
        name: "Advantages",
        keys: [
          {
            k0001: "Advantages",
          },
          {
            k0002: "Fast",
          },
          {
            k0003: "Analysis completed within 1 Month",
          },
          {
            k0004: "Projects Go-Live within 3-6 Months",
          },
          {
            k0005:
              "Increase your technology usage in business processes and start implementing your projects instead of suffering from ‘Analysis Paralysis’.",
          },
          {
            k0006: "Solution Providers",
          },
          {
            k0007: "Pool",
          },
          {
            k0008:
              "Solution Providers Pool,  providing right technologies for your needs",
          },
          {
            k0009:
              "Special Discounts and Demo Opportunities by our Solution Providers",
          },
          {
            k0010: "Facilitated Technology Procurement Process",
          },
          {
            k0011:
              "Overcome the difficulties in technology procurement by leveraging our solution providers pool.",
          },
          {
            k0012: "End to End",
          },
          {
            k0013: "E2E Support from Analysis to Implementation",
          },
          {
            k0014:
              "Full Monitoring & Reporting of the Projects on the Platform",
          },
          {
            k0015:
              "Get support at each stage of your projects so that your projects can go-live rather than remaining on-paper ideas.",
          },
          {
            k0016: "Flexible",
          },
          {
            k0017: "Flexible Monthly Subscription Model",
          },
          {
            k0018: "Fixed Rates",
          },
          {
            k0019:
              "Control your budget better with our flexible subscription model instead of paying high consulting fees.",
          },
          {
            k0020: "Contact Us",
          },
        ],
      },
      {
        id: 7,
        name: "Application",
        keys: [
          {
            k0001: "Join BANDWITT Solution Providers Pool!",
          },
          {
            k0002:
              "BANDWITT’s solution providers pool is growing day by day. Today more than 150 technology based companies that are experts in their fields work with us and match with the BANDWITT member companies that directly need their products and services worldwide.",
          },
          {
            k0003: "Name and Surname",
          },
          {
            k0004: "Email",
          },
          {
            k0005: "Phone Number",
          },
          {
            k0006: "Company Name",
          },
          {
            k0007: "Company’s Expertise Area",
          },
          {
            k0008: "Your Message",
          },
          {
            k0009: "Join for Free",
          },
          {
            k0010: "Company's Expertise Area",
          },
          {
            k0011: "Other",
          },
          {
            k0012: "Your Message",
          },
          {
            k0013: "Personal Data Protection",
          },
          {
            k0014: "I have read, I accept",
          },
          {
            k0015:
              "I would like to receive electronic messages within the scope of the ",
          },
          {
            k0016: "Consent Text",
          },
          {
            k0017: "to be informed about important campaigns.",
          },

          {
            k0018: "Join For Free",
          },
          {
            k0019: "You have successfully joined.",
          },
        ],
      },
      {
        id: 8,
        name: "FAQ",
        keys: [
          {
            k0001: "Frequently Asked Questions",
          },
          {
            k0002:
              "You can find the answers for FAQ about BANDWITT Platform. For further questions",
          },
          {
            k0003: "contact us.",
          },
          {
            k0004: "Do you only work with large-scale companies?",
          },
          {
            k0005:
              "The aim of the BANDWITT Platform is to ensure that all companies, regardless of their size and industry, have access to the right technologies they need. Our member firms include companies of all scales, such as micro-SMEs, SMEs and Large Enterprises.",
          },
          {
            k0006: "Do you provide services to companies from any industry?",
          },
          {
            k0007:
              "Yes. While some technology solutions are suitable for many companies regardless from their industry, industry-specific solutions may be needed in some cases. We evaluate your company's specific needs and match you with the most suitable solution providers.",
          },
          {
            k0008:
              "Can we work with our own solution providers on the projects? Or do we have to work with the solution providers in your pool only?",
          },
          {
            k0009:
              "We can also proceed with the solution providers that you are currently working with, or you recommend to us. The important point here is that whether your current solution provider can meet the technology needs of the project.  Sometimes the companies can not evaluate their solution from this perspective. Therefore, we kindly ask you to involve us in the process, if such cases arise. Thus, we can evaluate the related solution provider and  give our feedback about them to eliminate potential risks. ",
          },
          {
            k0010:
              "How do you charge your services? Can we become a member or suspend the membership any time we want?",
          },
          {
            k0011:
              "BANDWITT Platform has a monthly payment model where member companies pay a fixed monthly fee.  Currently, we have two different membership types and we determine together with you, which membership type will be more suitable for you based on your company’s needs.",
          },
          {
            k0012:
              "During your journey as a member of our platform, you pay a fixed monthly fee in your local currency. If you are not satisfied with our service or if you do not need  our services anymore by any reason, you can suspend your membership within the relevant month.",
          },
        ],
      },
      {
        id: 9,
        name: "Contact",
        keys: [
          {
            k0001:
              "We identify your company’s needs and match you with the most suitable technology solutions.",
          },
          {
            k0002: "Name and Surname",
          },
          {
            k0003: "Email",
          },
          {
            k0004: "Phone Number",
          },
          {
            k0005: "Company Name",
          },
          {
            k0006: "Your Message",
          },
          {
            k0007: "Send",
          },
          {
            k0008: "Personal Data Protection",
          },
          {
            k0009: "I have read, I accept",
          },
          {
            k0010:
              "I would like to receive electronic messages within the scope of the ",
          },
          {
            k0011: "Consent Text",
          },
          {
            k0012: "to be informed about important campaigns.",
          },
          {
            k0013: "Your message has been sent.",
          },
        ],
      },
      {
        id: 10,
        name: "Footer",
        keys: [
          {
            k0001: "Login",
          },
          {
            k0002: "Services",
          },
          {
            k0003: "References",
          },
          {
            k0004: "Advantages",
          },
          {
            k0005: "Solution Providers",
          },
          {
            k0006: "FAQ",
          },
          {
            k0007: "Contact",
          },
          {
            k0008: "Consent Text",
          },
          {
            k0009: "Privacy Policy",
          },
          {
            k0010: "Personal Data Protection",
          },
          {
            k0011: "Cookie Policy",
          },
          {
            k0012: "All Rights Reserved",
          },
        ],
      },
      {
        id: 11,
        name: "Company's Expertise Area",
        keys: [
          {
            k0001: "3D Technologies",
          },
          {
            k0002: "Vehicle Technologies",
          },
          {
            k0003: "Network and Infrastructure Solutions",
          },
          {
            k0004: "Barcode Solution Technologies",
          },
          {
            k0005: "Blockchain",
          },
          {
            k0006: "Cloud Based Solutions",
          },
          {
            k0007: "Big Data Management",
          },
          {
            k0008: "Chatbot Applications",
          },
          {
            k0009: "Digital Twin Technology",
          },
          {
            k0010: "Digital Access Solutions",
          },
          {
            k0011: "Digital Marketing",
          },
          {
            k0012: "Document Management Solutions",
          },
          {
            k0013: "Drone Technologies",
          },
          {
            k0014: "E-Signature and Mobile Signature Technologies",
          },
          {
            k0015: "E-Commerce Platforms",
          },
          {
            k0016: "Integrated Management Systems",
          },
          {
            k0017: "Education Technologies",
          },
          {
            k0018: "Financial Technologies (Fintech)",
          },
          {
            k0019: "Image Processing Technologies (OCR)",
          },
          {
            k0020: "Legal Technologies",
          },
          {
            k0021: "HR Platforms",
          },
          {
            k0022: "Advanced Planning Systems",
          },
          {
            k0023: "Advanced Manufacturing Technologies",
          },
          {
            k0024: "Workflow Management Systems",
          },
          {
            k0025: "Authentication Technologies",
          },
          {
            k0026: "Enterprise Management Systems (ERP)",
          },
          {
            k0027: "Customer Management Systems (CRM)",
          },
          {
            k0028: "Internet of Things (IoT)",
          },
          {
            k0029: "Platform Technologies",
          },
          {
            k0030: "Reporting Solutions",
          },
          {
            k0031: "Robotic Process Automation (RPA)",
          },
          {
            k0032: "Field Management Systems",
          },
          {
            k0033: "Virtual and Augmented Reality Technologies  (AR/VR)",
          },
          {
            k0034: "Health Technologies",
          },
          {
            k0035: "Cyber​​security Solutions",
          },
          {
            k0036: "Insurance Technologies",
          },
          {
            k0037: "Forecasting Systems",
          },
          {
            k0038: "Agricultural Technologies",
          },
          {
            k0039: "Web and Mobile Applications",
          },
          {
            k0040: "Artificial Intelligence and Machine Learning (AI/ML)",
          },
        ],
      },
      {
        id: 12,
        name: "URL Links",
        keys: [
          {
            k0001: "services",
          },
          {
            k0002: "references",
          },
          {
            k0003: "advantages",
          },
          {
            k0004: "application",
          },
          {
            k0005: "faq",
          },
          {
            k0006: "contact",
          },
        ],
      },
      {
        id: 13,
        name: "Slide",
        keys: [
          {
            k0001:
              "Today, digital transformation is not a choice for companies, it is a necessity. At the same time, it should function as a continuous and always-learning department.",
          },
          {
            k0002:
              "We have chosen to work with BANDWITT, because they share this vision and provide continuity and full-support while managing the projects. ",
          },
          {
            k0003: `In our "Digital Transformation" journey, - which is critical process for our company -, BANDWITT has guided us to the necessary steps with its accurate and comprehensive analyses and matched us with the right solution providers.`,
          },
          {
            k0004:
              "For many important projects in ERP, manufacturing, warehouse, field force, reporting and other areas, they have provided us with invaluable support, motivation and direction at every step,  both professionally and technically.",
          },
          {
            k0005: "We thank them for their valuable contributions.",
          },
          {
            k0006: "Accounting and Budgeting Manager",
          },
          {
            k0007:
              "BANDWITT is a very important strategic partner that companies can work with to realize their technology and digitalization investments in an environment where rapidly changing technology and increasing customer expectations are combined with pandemic conditions and economic crisis.",
          },
          {
            k0008:
              "In this challenging business environment, companies can meet with technology providers of all types by leveraging BANDWITT's knowledge and expertise. Thanks to the practical guidance provided by the team, they can implement the right solutions in this technology ecosystem where the new options are emerging continuously.",
          },
          {
            k0009: "Senior Project Manager & Banking Expert",
          },
          {
            k0010:
              "We started our digitalization journey in order to follow the rapidly changing technology trends and meet related business requirements. We made a good start with BANDWITT to accelerate the digitalization process and benefit from different perspectives. ",
          },
          {
            k0011:
              "While the evaluations and meetings enabled us to take clearer steps, BANDWITT’s wide pool of solution partners of provided a serious advantage for considering alternative solutions.",
          },
          {
            k0012: "Many thanks to BANDWITT for their support and cooperation.",
          },
          {
            k0013:
              "Working together with BANDWITT, we improved our digitalization skills and thanks to BANDWITT we had quick improvements in this area, despite the difficult pandemic conditions.",
          },
          {
            k0014: "General Manager",
          },
          {
            k0015: "IT Manager ",
          },
        ],
      },
      {
        id: 14,
        name: "Whatsapp Text",
        keys: [
          {
            k0001:
              "Hi,I would like to have further information about your services.",
          },
        ],
      },
      {
        id: 15,
        name: "Email Popup",
        keys: [
          {
            k0001:
              "I want to reach the right technology solutions for my company!",
          },
          {
            k0002: "Enter your email address",
          },
          {
            k0003: "Send",
          },
          {
            k0004: "Your email has been sent successfully.",
          },
          {
            k0005: "Your email could not be sent.",
          },
          {
            k0006: "Please Enter your email address!",
          },
        ],
      },
    ],
  },
];

export default languages;
